import React from "react";
import scanningimg from "../assets/img/scannerwithman2.gif";
import petrolpump from "../assets/img/team/petrolpump.jpg"
// import scanning from "../assets/img/Feeling angry.gif"

const NotScanned = () => {
  return (
    <>
      <h5 className="head mb-4">Dispenser data is not scanned for this dispenser No , <span style={{ color: "red" }}> "Kindly Please scan bluetooth device to get started"</span></h5>
      <div className="not-scanned">
        {/* <img className="image-fluid w-50" src={scanning} alt="bg-img" /> */}
        <img className="image-fluid mb-5" src={petrolpump} alt="bg-img" />
        <img className="image-fluid w-50 mt-10 " src={scanningimg} alt="bg-img" />
      </div>
    </>
  )
};

export default NotScanned;